import type { SVGProps } from 'react';

export function SupportIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#clip0_7383_19078)">
        <path
          d="M6.95486 0C3.66778 0 1 2.61334 1 5.83334C1 9.05335 3.66778 11.6667 6.95486 11.6667C10.2419 11.6667 12.9097 9.05335 12.9097 5.83334C12.9097 2.61334 10.2419 0 6.95486 0ZM11.3972 4.15334L9.74174 4.82418C9.43804 4.03084 8.80087 3.40084 7.98505 3.10917L8.66986 1.4875C9.92038 1.95417 10.9148 2.92834 11.3972 4.15334ZM6.95486 7.58335C5.96635 7.58335 5.1684 6.80168 5.1684 5.83334C5.1684 4.86501 5.96635 4.08334 6.95486 4.08334C7.94337 4.08334 8.74132 4.86501 8.74132 5.83334C8.74132 6.80168 7.94337 7.58335 6.95486 7.58335ZM5.24582 1.48167L5.94253 3.10334C5.12076 3.39501 4.47168 4.03084 4.16799 4.83584L2.51253 4.15917C2.99488 2.92834 3.98934 1.95417 5.24582 1.48167ZM2.51253 7.50751L4.16799 6.83668C4.47168 7.64168 5.11481 8.27168 5.93658 8.56335L5.23986 10.185C3.98934 9.71252 2.99488 8.73835 2.51253 7.50751ZM8.66986 10.185L7.98505 8.56335C8.80087 8.26585 9.44399 7.63585 9.74174 6.83084L11.3972 7.51335C10.9148 8.73835 9.92038 9.71252 8.66986 10.185Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_7383_19078">
          <rect width="13" height="11.9667" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
